import styled from 'styled-components';
import { useHoneypots } from './useHoneypots';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledField = styled.input.withConfig({
  displayName: "CustomInput__StyledField",
  componentId: "sc-1ilt3k8-0"
})(["opacity:0;position:absolute;z-index:-1;top:0;left:0;height:0;width:0;"]);

// NOTE: The name `CustomInput` is used here to avoid `Honeypot` appearing in the DOM.
// But these are specifically Honeypot elements.
const CustomInput = () => {
  const {
    honeypots,
    trackHoneypotInteraction
  } = useHoneypots();
  if (honeypots.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: honeypots.map(honeypot => /*#__PURE__*/_jsx(StyledField, {
      autoComplete: "off",
      "data-test-id": `CustomInput__${honeypot.key}`,
      tabIndex: -1,
      onChange: trackHoneypotInteraction
    }, honeypot.key))
  });
};
export default CustomInput;